varying vec3 vWorldPosition;
uniform sampler2D map;
uniform vec3 color;
uniform vec2 repeat;
uniform float depthOffset;
varying vec2 vUv;

void main() {
    float depth = distance(cameraPosition, vWorldPosition) + depthOffset;
    gl_FragColor = vec4(texture2D(map, vUv * repeat).rgb * color, depth);
}
